import { Controller } from "stimulus";
import updateValueInLocalStorage from "../functions/updateValueInLocalStorage";

export default class extends Controller {
  connect() {
    updateValueInLocalStorage(this.key, this.passphrase);
  }

  get passphrase() {
    return this.element.dataset.passphrase;
  }

  get key() {
    return this.element.dataset.key;
  }
}
